module.exports = __webpack_public_path__ + "img/car_shina2_08.eff28049.jpg";